module.exports = __webpack_public_path__ + "img/content-img.90ee78b.png";